import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ShieldAlert } from "lucide-react";

// Aviso previo a «Guardar sin análisis»: el archivo no se envía a ninguna IA.
export const useConfirmarNoClinico = () => {
  const [accion, setAccion] = useState(null);
  const [que, setQue] = useState("este archivo");
  const pedir = (fn, objeto = "este archivo") => { setQue(objeto); setAccion(() => fn); };
  const dialogo = accion && createPortal((
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" data-testid="no-clinico-dialogo">
      <div className="absolute inset-0 bg-[#1C2421]/50" onClick={() => setAccion(null)} />
      <div className="relative bg-white rounded-2xl p-6 max-w-md w-full shadow-xl">
        <ShieldAlert size={28} className="text-[#3A6B56]" />
        <p className="text-base text-[#1C2421] mt-3" data-testid="no-clinico-texto">
          AL DÍA Fácil no admite informes médicos, recetas ni documentación clínica. Confirma que {que} no contiene este tipo de información.
        </p>
        <button data-testid="no-clinico-confirmar" onClick={() => { const fn = accion; setAccion(null); fn(); }}
          className="w-full mt-5 min-h-[52px] px-4 py-2 rounded-xl bg-[#3A6B56] text-white font-semibold text-base hover:bg-[#2E5645]">
          Confirmo que no es documentación clínica
        </button>
        <button data-testid="no-clinico-cancelar" onClick={() => setAccion(null)}
          className="w-full mt-2 min-h-[44px] rounded-xl text-[#4A5550] font-semibold hover:bg-[#F2EDE4]">
          Cancelar
        </button>
      </div>
    </div>
  ), document.body);
  return { pedir, dialogo };
};
